import { isDevelopment } from "./environment";

interface LogContext {
  [key: string]: any;
}

/**
 * Centralized logger.
 *
 * - In development: logs to console
 * - In production: also logs to console
 */
class Logger {
  /**
   * Debug logs - development only
   */
  debug(message: string, context?: LogContext) {
    console.log(`🔍 ${message}`, context || "");
  }

  /**
   * Info logs
   */
  info(message: string, context?: LogContext) {
    console.log(`ℹ️ ${message}`, context || "");
  }

  /**
   * Warning logs
   */
  warn(message: string, context?: LogContext) {
    console.warn(`⚠️ ${message}`, context || "");
  }

  /**
   * Error logs
   */
  error(message: string, error?: Error | unknown, context?: LogContext) {
    console.error(`❌ ${message}`, error, context || "");
  }

  /**
   * Track custom events (e.g., business events like "Bing Ads triggered")
   */
  trackEvent(eventName: string, properties?: LogContext) {
    console.log(`📊 Event: ${eventName}`, properties || "");
  }

  /**
   * Set user context for all subsequent logs (no-op placeholder)
   */
  setUser(user: { id: string | number; email?: string; [key: string]: any }) {
    if (!isDevelopment) {
      // no-op; kept for API compatibility
    }
  }

  /**
   * Clear user context (e.g., on logout) (no-op placeholder)
   */
  clearUser() {
    if (!isDevelopment) {
      // no-op; kept for API compatibility
    }
  }

  /**
   * Add custom context that will be attached to all events (no-op placeholder)
   */
  setContext(key: string, context: LogContext) {
    if (!isDevelopment) {
      // no-op; kept for API compatibility
    }
  }
}

export const logger = new Logger();

